var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFont4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.4 500",
    style: {
      enableBackground: "new 0 0 330.4 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "106.2,480.3 84.831,309.852 81.215,266.047 80.43,238.106 81.421,202.163 83.328,178.27 85.495,162.438 88.566,146.748 92.546,131.281 97.426,116.066 101.705,104.871 106.583,93.924 112.122,83.297 118.379,73.077 122.979,66.544 127.94,60.281 133.278,54.336 139.003,48.763 145.116,43.621 151.6,38.953 158.423,34.797 165.551,31.191 172.948,28.174 180.571,25.785 188.368,24.046 196.28,22.938 204.253,22.438 212.242,22.519 220.206,23.158 228.108,24.336 235.909,26.062 243.562,28.357 251.011,31.242 258.195,34.737 265.042,38.85 271.514,43.534 277.639,48.662 286.308,56.938 305.249,77.511 315.499,89.771 322.738,99.322 329.462,109.233 337.629,122.954 346.778,140.73 356.489,162.63 364.906,185.085 372.02,207.966 377.882,231.213 390.981,301.921 394.853,329.61 396.621,349.5 397.345,369.448 397.155,381.436 395.977,397.337 393.247,417.099 387.81,444.512 386.9,448.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14.3,275.2 421.9,180.799 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "100.4,457.8 88.168,238.729 68.209,76.42 67.711,68.452 67.702,64.464 67.913,60.488 68.397,56.522 69.215,52.619 70.421,48.823 72.036,45.173 74.045,41.73 76.435,38.537 79.182,35.648 82.256,33.108 85.618,30.965 89.221,29.258 93.009,28.02 96.927,27.264 100.898,26.958 104.888,27.041 108.857,27.458 112.78,28.159 116.656,29.104 124.235,31.604 131.56,34.762 138.628,38.462 145.438,42.616 155.197,49.537 164.481,57.089 176.265,67.813 190.246,82.026 206.033,100.05 218.314,115.764 227.441,128.851 235.817,142.43 243.331,156.503 248.335,167.373 252.728,178.505 255.209,186.087 257.202,193.813 258.558,201.673 258.942,205.641 259.096,209.628 258.992,213.617 258.611,217.587 257.937,221.517 256.95,225.386 255.63,229.149 253.949,232.763 251.876,236.173 249.397,239.29 246.5,242.03 243.215,244.288 239.62,245.996 235.811,247.192 231.899,247.941 227.93,248.317 223.936,248.383 219.951,248.19 212.04,247.181 204.235,245.516 196.561,243.338 185.288,239.327 137.97,218.098 130.512,215.24 126.702,214.052 122.813,213.181 118.836,212.895 115.134,214.112 114.821,217.822 116.966,221.193 119.64,224.162 143.11,245.785 154.157,257.252 177.182,284.835 191.678,303.885 202.903,320.365 211.129,334.048 218.631,348.126 225.387,362.569 232.786,381.082 239.068,400.016 242.231,411.557 243.923,419.356 245.133,427.24 245.705,435.195 245.694,439.185 245.451,443.166 244.947,447.121 244.146,451.031 243.012,454.855 241.51,458.547 239.611,462.052 237.306,465.302 234.604,468.236 231.55,470.798 228.21,472.958 224.655,474.711 220.923,475.965 217.04,476.672 213.0,476.94 209.106,476.884 201.206,476.163 189.323,474.171 162.33,467.737 17.6,421.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "244.9,110.3 234.29,104.648 223.404,99.688 215.967,96.861 208.38,94.511 200.665,92.736 192.74,91.63 188.796,91.369 184.806,91.31 180.816,91.458 172.909,92.344 165.105,93.886 157.399,95.89 149.817,98.329 142.387,101.198 131.555,106.226 117.618,113.937 107.479,120.258 97.691,127.11 88.369,134.581 82.479,139.944 76.886,145.618 71.605,151.582 66.649,157.817 62.027,164.303 57.751,171.022 53.83,177.955 48.614,188.703 44.174,199.794 40.485,211.158 37.519,222.731 35.268,234.465 33.734,246.313 32.925,258.233 32.877,270.181 33.347,278.132 34.29,286.041 35.773,293.867 37.858,301.552 40.592,309.032 43.959,316.25 47.927,323.155 52.463,329.701 57.531,335.845 63.09,341.546 69.077,346.799 75.416,351.622 82.038,356.048 92.389,362.014 103.109,367.264 114.141,371.836 125.447,375.714 136.98,378.877 148.669,381.305 160.488,383.021 172.397,384.049 184.347,384.412 192.31,384.255 200.253,383.668 208.136,382.566 215.921,380.901 223.563,378.671 231.028,375.905 238.285,372.619 245.277,368.821 251.993,364.569 261.608,357.488 270.766,349.759 285.097,336.039 296.1,324.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "56.6,54.4 57.536,142.209 65.183,237.669 72.973,297.022 96.936,434.644 97.973,442.583 98.332,446.543 98.469,450.54 98.011,454.511 95.065,455.634 92.407,452.623 90.407,449.245 87.061,441.998 82.937,430.712 75.312,403.833 54.183,306.272 40.164,219.637 35.669,179.981 33.647,148.104 33.349,124.175 33.924,108.222 34.997,96.296 36.829,84.466 38.57,76.676 40.813,69.015 43.657,61.561 45.341,57.941 47.22,54.418 49.307,51.017 51.613,47.762 54.151,44.682 56.921,41.811 59.915,39.172 63.106,36.774 66.467,34.624 69.976,32.724 73.611,31.076 77.352,29.681 81.176,28.541 85.068,27.659 89.011,27.035 92.985,26.674 96.975,26.577 100.962,26.735 104.933,27.135 108.875,27.765 112.775,28.61 120.421,30.892 127.822,33.881 134.94,37.489 141.757,41.638 148.282,46.237 157.567,53.793 169.184,64.741 182.8,79.305 198.08,97.761 214.666,120.231 232.333,146.861 240.507,160.59 246.111,171.143 251.129,181.996 255.48,193.144 259.152,204.539 262.143,216.137 264.451,227.877 266.571,243.679 268.002,263.611 268.412,283.57 267.752,303.509 266.313,319.402 264.58,331.249 262.139,342.969 260.048,350.672 257.537,358.249 254.585,365.669 251.213,372.902 247.444,379.935 243.3,386.755 238.805,393.352 233.974,399.72 228.818,405.838 223.352,411.668 217.583,417.18 211.518,422.346 205.162,427.136 198.504,431.538 191.593,435.53 184.462,439.117 177.145,442.306 169.67,445.104 158.22,448.593 146.558,451.309 122.932,455.151 103.136,457.468 91.179,458.181 79.218,458.16 67.301,457.455 51.459,455.622 31.807,452.22 27.8,451.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "70.6,38.3 252.4,38.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.3,16.7 47.0,456.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.2,456.4 70.722,466.923 101.848,472.991 129.373,476.839 157.041,479.176 200.656,480.267 252.4,479.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "47.0,247.0 122.018,258.189 161.464,262.133 189.222,263.458 213.128,263.237 236.9,261.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "190.8,19.1 144.2,480.901 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.6,280.8 231.913,254.835 263.425,251.767 362.4,250.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17.3,76.1 332.879,41.241 376.442,38.567 420.1,37.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "268.4,30.6 256.599,28.222 244.714,26.619 236.763,26.088 228.8,26.079 220.88,26.688 213.019,28.012 209.155,28.965 205.32,30.126 201.571,31.48 194.314,34.736 187.331,38.597 177.26,45.063 167.689,52.24 158.668,60.093 150.17,68.52 136.912,83.389 100.044,130.554 83.966,153.386 64.976,183.848 53.387,204.789 46.503,219.185 41.983,230.257 38.068,241.552 33.743,256.917 30.393,272.524 27.941,288.275 25.969,308.14 25.043,328.093 25.114,344.056 26.058,359.956 27.436,371.844 29.503,383.632 31.325,391.4 33.548,399.061 36.209,406.583 39.335,413.923 42.924,421.048 46.966,427.926 51.453,434.523 56.371,440.804 61.705,446.737 67.44,452.283 73.564,457.397 80.063,462.023 86.919,466.101 94.105,469.564 101.577,472.356 109.254,474.52 117.064,476.148 128.918,477.798 144.829,478.997 160.782,479.342 172.742,478.92 184.656,477.791 196.478,475.857 208.133,473.119 219.566,469.609 230.739,465.355 241.632,460.36 252.138,454.63 258.892,450.396 265.421,445.824 271.705,440.912 280.647,432.961 289.051,424.441 299.548,412.423 309.363,399.841 316.109,389.958 320.178,383.095 323.799,375.986 326.873,368.625 329.314,361.03 331.066,353.247 332.063,345.334 332.257,341.35 332.234,337.36 331.987,333.378 331.508,329.418 330.79,325.494 329.835,321.621 328.649,317.812 327.239,314.08 325.609,310.439 323.765,306.901 321.713,303.48 319.458,300.189 317.005,297.042 314.361,294.055 311.532,291.243 308.528,288.62 305.36,286.199 302.044,283.984 298.597,281.976 295.036,280.171 291.383,278.563 283.873,275.895 276.161,273.863 268.32,272.365 260.417,271.334 252.485,270.764 240.529,270.68 228.596,271.344 208.74,273.63 181.2,278.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "193.4,283.8 316.684,272.446 340.762,271.288 348.711,271.3 356.549,271.765 360.501,272.28 364.413,273.036 368.286,274.037 372.082,275.301 375.758,276.863 379.262,278.758 382.541,281.03 385.506,283.703 388.052,286.768 390.097,290.192 391.576,293.894 392.481,297.78 392.872,301.749 392.852,305.739 392.512,309.727 391.159,317.586 388.129,329.179 368.203,394.058 352.538,460.001 351.7,464.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "43.6,28.7 50.187,337.996 63.8,484.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "199.0,17.5 214.118,135.978 222.082,247.043 223.128,286.809 221.049,358.304 211.6,473.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "53.7,270.7 284.2,253.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "36.1,30.0 59.2,470.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "164.8,18.8 188.223,164.834 193.113,212.417 196.878,280.228 197.011,320.17 194.807,372.058 192.637,395.94 190.964,407.797 188.588,419.564 186.474,427.264 183.817,434.792 180.518,442.056 178.605,445.554 176.506,448.957 174.231,452.241 171.79,455.402 169.185,458.427 166.402,461.299 163.441,463.982 160.295,466.435 156.945,468.62 153.406,470.467 149.684,471.91 145.81,472.875 141.842,473.294 137.857,473.144 133.913,472.477 130.083,471.379 126.365,469.926 122.765,468.184 119.281,466.211 112.661,461.758 106.403,456.794 100.451,451.475 92.104,442.981 71.569,418.595 22.8,355.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "56.0,17.8 91.1,455.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "272.8,34.7 126.931,152.168 88.085,186.507 71.264,202.879 62.993,211.783 57.88,217.899 53.331,224.207 51.293,227.636 49.613,231.206 48.496,234.869 48.127,238.79 48.564,242.738 49.44,246.618 50.655,250.402 52.186,254.07 53.996,257.608 56.047,261.015 60.709,267.454 65.888,273.488 267.6,482.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "124.4,18.9 45.904,320.638 35.969,367.175 33.404,382.742 32.17,394.424 32.012,398.696 32.1,402.488 32.519,406.418 33.338,410.298 34.431,414.107 35.734,417.874 37.252,421.559 38.995,425.143 40.966,428.607 43.162,431.936 45.569,435.114 48.169,438.135 50.942,440.997 56.917,446.272 63.31,451.007 66.647,453.141 70.184,455.058 73.741,456.67 81.303,459.362 92.738,462.331 112.328,465.943 171.627,472.806 279.4,480.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "52.8,100.3 57.087,340.844 59.302,376.891 60.574,388.635 61.177,392.517 62.006,396.357 63.669,399.643 65.89,396.733 66.964,392.957 69.253,380.975 74.452,337.286 84.856,193.655 91.001,146.103 97.296,110.641 101.775,91.166 105.122,79.627 107.794,72.107 111.004,64.786 112.88,61.248 114.982,57.841 117.35,54.623 120.018,51.666 123.038,49.039 126.386,46.865 130.02,45.206 133.859,44.099 137.818,43.555 141.814,43.564 145.774,44.103 149.633,45.143 153.336,46.649 156.832,48.584 160.088,50.911 163.076,53.558 165.817,56.469 168.324,59.591 170.607,62.87 172.689,66.282 176.311,73.413 179.285,80.837 181.678,88.466 183.556,96.239 185.578,108.062 187.202,123.972 188.546,155.92 187.882,283.914 188.179,291.878 188.487,295.906 189.01,299.828 190.125,303.698 193.217,304.613 195.411,301.264 196.841,297.586 197.98,293.737 199.717,285.952 201.569,274.078 210.328,142.362 212.554,122.49 215.202,106.741 218.679,91.131 221.993,79.603 224.643,72.059 227.711,64.674 231.253,57.503 235.322,50.619 237.578,47.32 240.0,44.136 242.601,41.094 245.392,38.231 248.386,35.587 251.599,33.206 255.031,31.153 258.664,29.494 262.468,28.263 266.386,27.471 270.367,27.119 274.363,27.202 278.329,27.708 282.221,28.623 285.997,29.932 289.625,31.615 293.064,33.652 296.29,36.009 299.304,38.637 302.117,41.485 304.736,44.501 309.483,50.933 313.685,57.74 319.215,68.385 324.046,79.364 328.25,90.598 332.95,105.884 336.705,121.418 340.297,141.08 344.673,176.811 347.608,220.699 348.148,256.67 346.92,284.597 322.2,483.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "58.9,472.5 57.5,168.839 51.815,85.42 51.671,77.414 51.811,73.439 52.219,69.444 53.149,65.565 55.468,62.447 59.158,63.13 61.96,65.97 64.174,69.248 66.099,72.738 69.428,80.044 73.607,91.306 81.461,118.072 117.822,277.736 131.474,323.595 169.469,433.076 175.389,447.851 177.079,451.48 178.964,455.039 181.148,458.363 183.987,461.131 187.782,461.843 191.222,459.861 193.864,456.886 196.041,453.555 197.936,450.019 201.108,442.7 203.716,435.143 206.834,423.584 211.351,400.059 218.788,344.7 233.695,169.784 241.3,22.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "290.6,40.8 258.841,36.716 238.964,35.252 226.997,35.056 215.051,35.606 207.12,36.479 199.246,37.771 191.453,39.496 183.774,41.675 176.242,44.315 168.883,47.4 158.177,52.767 147.874,58.872 138.001,65.65 128.584,73.05 119.65,81.002 111.221,89.498 103.375,98.565 98.532,104.923 94.042,111.529 89.931,118.373 84.392,128.992 76.386,147.276 67.885,169.7 63.019,184.897 60.011,196.475 57.662,208.219 55.962,220.075 54.646,235.989 54.366,251.972 54.875,263.932 56.058,275.834 57.96,287.663 60.601,299.34 63.992,310.841 68.133,322.078 73.037,332.994 78.659,343.568 87.06,357.147 96.247,370.21 103.637,379.635 108.903,385.638 114.507,391.326 120.496,396.605 126.901,401.369 133.687,405.575 140.775,409.25 148.095,412.437 155.595,415.18 167.084,418.56 178.773,421.165 190.596,423.082 206.478,424.732 222.43,425.48 234.406,425.288 242.368,424.694 250.285,423.654 258.118,422.109 265.838,420.072 273.43,417.602 284.574,413.215 299.004,406.406 309.533,400.697 319.746,394.409 329.518,387.493 338.765,379.879 347.44,371.63 355.58,362.847 365.682,350.475 372.719,340.745 379.134,330.634 382.995,323.662 386.476,316.492 389.538,309.118 392.179,301.583 395.416,290.053 397.87,278.33 399.633,266.483 400.747,254.559 401.185,242.589 400.914,230.616 399.879,218.684 398.695,210.788 397.044,202.977 394.868,195.295 392.116,187.801 388.758,180.56 384.841,173.603 380.462,166.925 373.216,157.391 365.358,148.351 354.213,136.91 336.47,120.815 321.034,108.167 311.415,101.03 301.422,94.429 294.521,90.413 283.82,85.035 272.805,80.334 254.006,73.621 234.849,67.897 219.339,64.136 203.655,61.277 187.814,59.373 167.872,58.189 151.902,58.108 139.939,58.688 128.036,60.017 120.177,61.419 112.422,63.311 104.821,65.749 97.419,68.744 90.257,72.256 83.335,76.226 76.644,80.58 70.199,85.307 64.127,90.458 58.45,96.066 53.2,102.054 48.321,108.396 41.698,118.326 35.697,128.751 28.599,142.976 26.9,146.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "62.4,65.6 137.2,485.099 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.4,59.3 36.886,49.243 46.515,42.31 56.686,35.911 63.685,32.146 70.893,28.886 78.445,26.218 82.273,25.18 86.149,24.356 90.087,23.756 94.059,23.393 98.041,23.266 102.022,23.364 105.99,23.687 109.932,24.243 113.833,25.032 117.685,26.054 121.47,27.297 125.179,28.749 132.352,32.208 139.205,36.27 145.781,40.766 155.188,48.134 164.05,56.151 172.372,64.726 180.163,73.786 187.426,83.267 196.324,96.483 204.363,110.246 211.584,124.45 218.031,139.026 223.734,153.901 227.473,165.252 230.596,176.787 232.944,188.502 234.0,196.399 234.615,204.342 234.786,212.307 234.512,220.269 233.786,228.203 232.599,236.082 230.937,243.874 228.751,251.533 225.96,258.996 224.313,262.623 222.485,266.162 220.467,269.594 218.248,272.904 215.826,276.066 213.199,279.059 210.377,281.871 207.379,284.494 204.226,286.926 200.933,289.168 197.517,291.219 193.994,293.081 190.38,294.755 182.921,297.548 175.228,299.615 167.381,300.974 159.452,301.68 151.49,301.819 139.561,301.177 123.755,299.187 88.657,292.147 42.1,281.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "295.5,54.3 286.066,46.822 276.254,39.922 269.471,35.735 262.456,31.961 255.207,28.711 247.674,26.095 243.831,25.079 239.902,24.273 235.953,23.704 231.986,23.378 228.006,23.297 224.026,23.452 216.109,24.396 208.32,26.123 200.737,28.602 193.406,31.748 186.328,35.427 169.354,45.931 156.254,55.044 143.661,64.821 131.677,75.321 109.108,97.923 92.946,115.582 82.823,127.919 75.829,137.626 69.445,147.747 61.798,161.768 55.025,176.211 49.048,191.037 45.206,202.356 41.994,213.873 39.489,225.546 37.686,237.37 36.563,249.306 36.104,261.284 36.448,277.214 38.481,301.079 41.671,324.814 43.923,336.569 46.888,348.164 49.353,355.744 53.771,366.854 58.916,377.672 66.629,391.654 75.128,405.205 82.057,414.954 89.553,424.251 97.696,433.016 103.484,438.509 109.553,443.691 115.896,448.531 122.509,452.996 129.383,457.048 136.494,460.667 143.797,463.881 155.019,468.042 170.308,472.614 185.846,476.295 197.653,478.325 209.537,479.548 217.503,479.837 229.444,479.481 241.358,478.324 257.148,475.828 272.754,472.489 284.274,469.246 291.807,466.616 299.171,463.543 306.313,459.987 313.21,455.974 319.858,451.562 329.374,444.304 338.367,436.405 346.865,427.947 354.789,419.002 362.133,409.565 368.866,399.662 374.987,389.377 382.323,375.205 388.865,360.649 393.174,349.492 395.598,341.897 397.611,334.181 399.893,322.429 401.406,310.57 402.737,290.639 402.998,262.7 401.935,238.782 400.356,222.901 397.871,207.15 390.71,176.049 387.481,164.522 384.966,156.949 382.041,149.527 378.602,142.327 374.596,135.427 370.077,128.852 365.112,122.607 359.763,116.686 354.086,111.077 345.063,103.216 335.555,95.945 322.342,86.997 308.722,78.678 298.17,73.041 290.884,69.792 283.388,67.064 275.708,64.908 267.894,63.34 259.996,62.308 248.056,61.503 184.2,62.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "192.4,319.6 309.21,396.14 346.84,418.275 364.636,427.512 375.516,432.38 382.882,435.121 386.699,436.292 390.54,437.251 394.328,437.947 398.339,438.396 410.217,438.609 422.136,438.046 434.008,436.598 445.728,434.324 461.092,430.283 479.97,424.086 483.8,422.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "108.7,55.0 75.543,331.821 51.3,477.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "80.0,61.7 88.323,52.983 97.147,44.822 103.347,39.797 109.858,35.186 116.698,31.113 120.275,29.307 123.895,27.711 127.644,26.306 131.476,25.131 135.358,24.209 139.286,23.545 143.25,23.139 147.236,22.981 151.228,23.048 155.213,23.315 159.182,23.787 163.12,24.474 167.012,25.383 170.843,26.518 174.599,27.879 178.266,29.46 181.835,31.251 185.299,33.24 191.895,37.743 198.058,42.825 203.808,48.374 209.163,54.303 214.153,60.543 221.016,70.368 227.213,80.626 232.791,91.234 237.778,102.132 243.565,117.026 248.422,132.25 252.33,147.744 255.245,163.455 256.683,175.354 257.163,183.33 257.162,191.319 256.585,199.287 255.334,207.177 253.332,214.91 252.038,218.69 250.543,222.396 248.843,226.011 246.937,229.522 244.821,232.91 242.494,236.158 239.96,239.245 237.221,242.153 234.286,244.864 231.175,247.37 227.914,249.675 224.522,251.785 221.019,253.708 213.749,257.024 206.218,259.687 198.501,261.759 190.659,263.289 182.739,264.341 170.784,265.176 154.804,265.269 134.849,264.363 114.972,262.394 83.426,257.246 75.48,256.364 71.493,256.174 67.5,256.221 63.517,256.569 59.588,257.285 55.758,258.417 52.086,260.001 48.683,262.078 45.677,264.71 43.292,267.901 41.756,271.58 41.221,275.515 41.637,279.499 42.864,283.211 44.839,286.675 47.176,289.834 52.458,295.806 66.577,309.457 279.7,485.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "294.0,79.0 282.763,67.55 274.028,59.486 264.761,51.817 258.358,47.093 251.733,42.725 244.787,38.724 237.659,35.225 230.264,32.187 218.912,28.425 211.203,26.382 203.391,24.772 195.496,23.652 187.545,23.062 179.569,23.021 171.607,23.514 163.692,24.507 155.848,25.963 148.095,27.84 136.658,31.361 125.476,35.623 114.613,40.641 107.608,44.459 100.846,48.693 94.388,53.377 88.305,58.535 82.677,64.19 80.066,67.207 77.612,70.351 75.331,73.623 73.242,77.021 71.364,80.541 69.721,84.176 68.331,87.914 67.211,91.742 66.36,95.638 65.766,99.582 65.419,103.557 65.304,107.546 65.41,111.532 66.234,119.465 67.804,127.287 70.046,134.942 72.886,142.396 76.243,149.634 80.038,156.651 86.409,166.78 93.431,176.47 100.989,185.748 111.784,197.497 123.253,208.574 144.48,226.696 233.029,294.814 257.267,315.57 274.633,332.071 288.303,346.583 298.498,358.835 305.601,368.466 312.128,378.496 317.967,388.94 321.418,396.134 324.439,403.52 326.91,411.104 327.89,414.968 328.67,418.884 329.217,422.837 329.5,426.814 329.485,430.8 329.137,434.775 328.437,438.702 327.389,442.549 326.004,446.29 324.296,449.894 322.281,453.336 319.974,456.59 317.394,459.631 314.559,462.437 311.49,464.986 308.213,467.256 304.753,469.241 301.15,470.957 297.443,472.424 293.654,473.668 285.909,475.584 278.036,476.877 266.118,477.96 254.185,478.253 242.229,477.762 230.316,476.446 218.539,474.274 206.951,471.29 191.797,466.297 173.281,458.885 158.808,452.169 148.232,446.57 137.976,440.404 128.12,433.624 118.708,426.234 109.788,418.255 101.411,409.709 93.598,400.649 81.598,384.731 25.8,297.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "26.5,26.7 399.5,54.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "265.2,20.9 246.701,479.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "392.2,72.1 385.439,255.918 383.563,279.646 379.711,307.185 376.666,322.851 373.65,334.442 371.177,342.03 366.754,353.158 361.606,363.971 353.879,377.944 345.371,391.456 338.315,401.132 333.192,407.255 327.682,413.032 321.761,418.387 315.479,423.313 308.904,427.841 298.615,433.968 287.952,439.422 277.005,444.279 265.786,448.466 254.308,451.881 246.527,453.671 238.647,455.044 230.718,455.982 222.756,456.479 214.78,456.528 206.808,456.121 198.873,455.254 191.002,453.913 183.231,452.078 175.601,449.733 168.154,446.859 160.936,443.442 153.99,439.507 147.324,435.114 140.937,430.323 134.822,425.188 126.139,416.941 118.013,408.145 110.424,398.884 101.083,385.931 94.642,375.835 88.787,365.404 81.873,351.014 72.941,328.779 58.907,287.15 50.111,256.44 43.909,229.217 39.574,205.724 37.565,189.966 34.786,138.266 33.7,38.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "25.7,51.7 80.435,226.637 88.498,257.381 118.129,413.966 121.025,425.533 122.245,429.339 123.703,433.037 125.566,436.549 128.106,439.589 131.567,441.466 135.5,441.352 139.067,439.619 142.108,437.077 144.775,434.099 147.126,430.912 149.267,427.559 153.079,420.542 158.038,409.68 245.601,170.294 317.2,14.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "28.7,42.3 97.826,386.469 108.464,429.128 111.955,440.78 114.663,448.374 116.17,451.83 118.053,455.128 121.16,457.532 124.931,456.68 127.76,453.925 129.855,450.545 131.558,446.957 134.388,439.503 166.067,319.911 174.617,281.037 191.8,162.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "404.7,18.0 386.608,200.473 382.061,232.096 354.665,352.555 343.122,394.844 336.885,413.743 331.134,428.604 326.207,439.506 322.355,446.48 320.154,449.809 317.703,452.956 314.934,455.816 311.77,458.223 308.193,459.975 304.325,460.897 300.35,460.9 296.474,460.013 292.851,458.36 289.568,456.097 286.667,453.382 284.098,450.317 281.835,447.056 279.788,443.636 276.174,436.516 268.63,418.077 179.1,158.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "32.3,15.1 308.4,470.999 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "308.4,74.2 262.168,162.611 244.143,193.573 233.287,210.199 223.905,222.973 91.821,382.44 72.568,407.802 63.541,420.901 55.209,434.465 45.786,451.96 32.3,480.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "234.2,66.3 96.5,485.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.6,14.4 182.3,323.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "z.4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "82.6,80.1 326.181,82.152 358.311,83.759 370.147,84.883 378.054,86.077 382.05,86.972 385.751,88.163 389.242,89.944 392.279,92.458 394.713,95.602 396.317,99.247 397.007,103.168 396.861,107.157 396.029,111.055 394.651,114.804 392.837,118.364 390.666,121.713 388.189,124.846 385.457,127.761 382.531,130.472 376.246,135.398 369.596,139.825 90.957,304.201 74.16,315.11 64.505,322.15 58.522,327.31 55.741,330.19 53.26,333.3 51.182,336.72 49.652,340.396 48.724,344.279 49.215,348.209 51.576,351.354 54.633,353.502 58.364,355.309 61.845,356.612 69.564,358.819 81.541,361.271 108.664,364.887 184.287,369.88 372.8,372.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont4);
export default __webpack_public_path__ + "static/media/font4.b33dfdc6516504f1e57a984e91a282c5.svg";
export { ForwardRef as ReactComponent };